import { Heading, Type, AlignLeft, ToggleLeft, ShieldCheck, Hash, CalendarDays, ChevronDownSquare, ListChecks, Camera, PenLine, MapPin } from "lucide-react";

export const FIELD_TYPES = [
  { v: "heading", label: "Section heading", icon: Heading },
  { v: "short_text", label: "Short text", icon: Type },
  { v: "long_text", label: "Long text", icon: AlignLeft },
  { v: "yes_no", label: "Yes / No", icon: ToggleLeft },
  { v: "pass_fail", label: "Pass / Fail / N/A", icon: ShieldCheck },
  { v: "number", label: "Number", icon: Hash },
  { v: "date", label: "Date", icon: CalendarDays },
  { v: "dropdown", label: "Dropdown", icon: ChevronDownSquare },
  { v: "site", label: "Site (dropdown)", icon: MapPin },
  { v: "checkboxes", label: "Checkbox list", icon: ListChecks },
  { v: "photo", label: "Photo upload", icon: Camera },
  { v: "signature", label: "Signature", icon: PenLine },
];
export const fieldMeta = (t) => FIELD_TYPES.find((x) => x.v === t) || FIELD_TYPES[1];
export const hasOptions = (t) => t === "dropdown" || t === "checkboxes";

export const FREQUENCIES = [
  { v: "daily", label: "Daily" },
  { v: "weekly", label: "Weekly" },
  { v: "monthly", label: "Monthly" },
  { v: "once", label: "One-off" },
];
export const freqLabel = (v) => FREQUENCIES.find((f) => f.v === v)?.label || v;
